import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/inquiries").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <h2 className="font-serif-display text-2xl mb-6">Concierge inquiries ({items.length})</h2>
      {items.length === 0 ? (
        <div className="text-center py-16 text-[hsl(100_3%_30%)]">No messages yet.</div>
      ) : (
        <div className="space-y-3">
          {items.map((i) => (
            <div key={i.id} className="border border-[hsl(165_37%_17%/0.1)] rounded-md bg-white p-5" data-testid={`inquiry-${i.id}`}>
              <div className="flex items-start justify-between gap-4 mb-2">
                <div>
                  <p className="font-medium">{i.subject}</p>
                  <p className="text-xs text-[hsl(100_3%_30%)]">
                    From {i.name} · {i.email} {i.phone ? `· ${i.phone}` : ""}
                  </p>
                </div>
                <div className="text-right">
                  <Badge>{i.status}</Badge>
                  <p className="text-xs text-[hsl(100_3%_30%)] mt-1">{new Date(i.created_at).toLocaleString()}</p>
                </div>
              </div>
              <p className="text-sm leading-relaxed mt-3 whitespace-pre-line">{i.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
